import React, { useState } from "react"
import { Button, Modal } from "react-daisyui"
import BaseButton from "../components/Button/base-button"
import LoginDropdown from "../features/auth/components/login-dropdown"
import { RecruiterPortal } from "../utils/constants"

type ManageModelsProps = {
  isOpen: boolean
  setIsModelOpen: (isOpen: boolean, buttonSelection: string) => void
  buttonSelection: string
  measuresMenu: { value: string; label: string }[]
  compositeScoresMenu: { value: string; label: string }[]
  handleSubmit: (selectedId: string) => void
  maxScore: number
}
const ManageModels: React.FC<ManageModelsProps> = ({
  isOpen,
  setIsModelOpen,
  buttonSelection,
  measuresMenu,
  compositeScoresMenu,
  handleSubmit,
  maxScore,
}) => {
  const [overlayValue, setOverlayValue] = useState("")
  const [showErrorMsg, setShowErrorMsg] = useState(false)
  const maxOverlay = maxScore // Replace with your desired max value

  const [selectedMeasureId, setSelectedMeasureId] = useState<string | null>(
    null,
  )
  const [selectedCompositeId, setSelectedCompositeId] = useState<string | null>(
    null,
  )
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setOverlayValue(value)
    if (Number(value) < 0 || Number(value) > maxOverlay) {
      setShowErrorMsg(true)
    } else {
      setShowErrorMsg(false)
    }
  }

  const handleCompositeIdSelection = (value: string, type?: string) => {
    if (type === "measures") {
      setSelectedMeasureId && setSelectedMeasureId(value)
    } else {
      setSelectedCompositeId && setSelectedCompositeId(value)
    }
  }

  return (
    <Modal open={isOpen}>
      <Modal.Header className="flex justify-between items-center">
        <span className="font-bold text-lg " style={{ color: "white" }}>
          {buttonSelection && buttonSelection !== RecruiterPortal.Composite
            ? buttonSelection == "overlay"
              ? "Overlay"
              : "Measures"
            : "Composite scores set"}
        </span>
        <Button
          className="btn-sm text-gray-700 bg-base-white shadow-none border-[1px] border-solid border-gray-300 hover:text-gray-700 hover:bg-blue-light-200"
          shape="circle"
          onClick={() => setIsModelOpen(false, buttonSelection)}>
          ✕
        </Button>
      </Modal.Header>
      <Modal.Body className="self-stretch flex flex-col items-start justify-start gap-[20px]">
        {buttonSelection == "overlay" && (
          <div className="items-start w-full justify-start gap-[6px] text-left text-sm text-gray-700 font-text-md-regular1">
            <div className="self-stretch w-full flex flex-col items-start justify-start gap-[6px]">
              <label style={{ fontSize: "15px", fontWeight: "bold" }}>
                Reference Line
              </label>
              <input
                className="self-stretch w-full h-[40px] rounded-lg bg-base-white shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row px-1 items-center justify-start gap-[8px] text-base text-gray-500 border-[1px] border-solid border-gray-300 focus:outline-offset-0"
                type="number"
                min="0"
                max={maxOverlay}
                name="search"
                value={overlayValue}
                onChange={handleInputChange}
                autoComplete="off"
                placeholder="Input"
              />
              {showErrorMsg && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please enter a number between 0 and {maxOverlay + 1}.
                </span>
              )}
            </div>
          </div>
        )}

        {buttonSelection &&
          (buttonSelection == RecruiterPortal.Composite ||
            buttonSelection == "measures") && (
            <LoginDropdown
              id={
                buttonSelection && buttonSelection !== RecruiterPortal.Composite
                  ? "selectMeasure"
                  : "selectCompositeScoresSet"
              }
              titleText={
                buttonSelection && buttonSelection !== RecruiterPortal.Composite
                  ? "Select measure name"
                  : "Select composite scores set name"
              }
              placeholderText={
                buttonSelection && buttonSelection !== RecruiterPortal.Composite
                  ? "Select measure name"
                  : "Select composite scores set name"
              }
              options={
                buttonSelection && buttonSelection !== RecruiterPortal.Composite
                  ? measuresMenu
                  : compositeScoresMenu
              }
              defaultValue={selectedCompositeId?.toString() ?? ""}
              setValue={(value: string) =>
                buttonSelection && buttonSelection !== RecruiterPortal.Composite
                  ? handleCompositeIdSelection(value, "measures")
                  : handleCompositeIdSelection(value, RecruiterPortal.Composite)
              }
              showNoneOption={true}
              disable={false}
            />
          )}
      </Modal.Body>
      <Modal.Actions>
        <BaseButton
          variant="primary"
          onClick={() => {
            handleSubmit(
              buttonSelection && buttonSelection !== RecruiterPortal.Composite
                ? buttonSelection === "overlay"
                  ? overlayValue
                  : (selectedMeasureId?.toString() ?? "")
                : (selectedCompositeId?.toString() ?? ""),
            )
            setOverlayValue("")
            setShowErrorMsg(false)
          }}
          loading={false}>
          Submit
        </BaseButton>
        <BaseButton
          variant="secondary"
          onClick={() => {
            setOverlayValue("")
            setShowErrorMsg(false)
            setIsModelOpen(false, buttonSelection)
          }}>
          Cancel
        </BaseButton>
      </Modal.Actions>
    </Modal>
  )
}

export default ManageModels
